import { Box, styled, Tab, Tabs, Typography } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { useState } from 'react';
import { getRenderType, setRenderType } from '../../reducer/renderTypeSlice';

const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
    ({ theme }) => ({
        textTransform: 'none',
        fontWeight: theme.typography.fontWeightRegular,
        fontSize: theme.typography.pxToRem(15),
        minHeight: '40px',
        height: '40px',
        color: 'black',
        '&.Mui-selected': {
            color: '#fff',
            zIndex: 2
        },
        '&.Mui-focusVisible': {
            backgroundColor: 'rgba(100, 95, 228, 0.32)',
        },
    }),
);

function RenderTypeSetting() {
    const renderType = useSelector(getRenderType);
    const dispatch = useDispatch();
    const [renderTypeSelected, setRenderTypeSeleceted] = useState(renderType);

    const handleChange = (event, newValue) => {
        setRenderTypeSeleceted(newValue);
        dispatch(setRenderType(newValue));
    };
    return (
        <>

            <Box sx={{
                textAlign: 'left'
            }}>
                <Typography 
                    variant="h6"
                    component="h6" 
                    sx={{
                        color: 'black',
                        fontSize: '1rem',
                        fontWeight: '400'
                }}>
                    การปักหมุด
                </Typography>
                <Tabs 
                    value={renderTypeSelected}
                    variant="fullWidth"
                    onChange={handleChange}
                    sx={{
                        marginTop: '8px',
                        minHeight: '40px',
                        height: '40px',
                        backgroundColor: 'rgba(0, 0, 0, 0.23)',
                        // boxShadow: 'rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px',
                        borderRadius: '4px',
                        '& .MuiTabs-indicator': {
                            backgroundColor: 'rgb(62, 152, 211)',
                            zIndex: 1,
                            height: '100%'
                        }
                    }}
                >
                    <StyledTab label="รวมกลุ่ม" value="cluster" />
                    <StyledTab label="ทั้งหมด" value="all" />
                </Tabs>
            </Box>
        </>
    )
}

export default RenderTypeSetting;